import http from "infra/http";
import { useQuery } from "react-query";
import { TaskResponse } from "../typings";

function useTasks(enabled = false) {
  return useQuery(
    `/v1/task`,
    async () => {
      const { data } = await http.get<TaskResponse[]>(`/v1/task`);
      return data;
    },
    { enabled, refetchInterval: 10000 }
  );
}

export default useTasks;
